

export function calculateContainerSize(wSize, aspectRatio) {

    var currentWidth = wSize.width;//div.width();
    var currentHeight = wSize.height;//div.height();
    var nWidth = currentWidth;
    var nHeight = currentWidth * (1/aspectRatio);
    //check height
    if (currentHeight<nHeight) {
      nWidth = currentHeight * aspectRatio;
      nHeight = currentHeight;
    }

    var contSize = {
      width: nWidth,
      height: nHeight,
      leftMargin: (currentWidth-nWidth)/2,
      topMargin: (currentHeight-nHeight)/2,
      scaleRatio: nWidth / 1920
    };

    return contSize;
}

export function getValueByQueryString(paramName) {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let sessionId = params.get(paramName);
    return sessionId;
}